






































import Vue from 'vue'
import {
  Configuration,
  PositionDetail,
  PositionMeetingDetail,
  ConferenceDoctorPositionRestControllerApi,
} from '@/types/api-docs'
import CommitteeDetailForm from '@/components/CommitteeDetailForm.vue'

export interface DataType {
  pageName: string
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  breadcrumbs: Array<any>
  position?: PositionDetail
  positionMeetings: Array<PositionMeetingDetail>
  positionsId: number
  isFormValid: boolean
}

const api = new ConferenceDoctorPositionRestControllerApi(new Configuration({ basePath: `${window.location.origin}` }))

export default Vue.extend({
  components: {
    CommitteeDetailForm,
  },
  data(): DataType {
    return {
      pageName: this.$route.meta.title,
      breadcrumbs: [
        {
          text: 'HOME',
          href: '/member',
        },
        {
          text: '委員会一覧',
          href: '/member/positions',
        },
        {
          text: `${this.$route.meta.title}`,
          disabled: true,
        },
      ],
      position: undefined,
      positionMeetings: [],
      positionsId: Number(this.$route.params.id),
      isFormValid: true,
    }
  },
  async mounted() {
    await this.fetchPositionDetail()
    await this.fetchPositionMeetingDetails()
  },
  computed: {},
  methods: {
    async fetchPositionDetail() {
      const { data } = await api.fetchMemberPositionMaster(this.positionsId)
      this.position = data
    },
    async fetchPositionMeetingDetails() {
      const { data } = await api.fetchMemberPositionMasterMeetings(this.positionsId)
      this.positionMeetings = data.content ? data.content : []
    },
  },
})
